export enum Color {
  Graphite = 'graphite',
  White = 'white',
  Additional = 'additional',
}
